import { Warehouse } from 'lucide-react'
import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '@lib/permissions/guards'
import DepotsTab from '@features/stock/components/DepotsTab'

export const Route = createFileRoute('/_app/stock/depots')({
  staticData: {
    title: 'Depôts',
    icon: Warehouse,
    tab_icon: Warehouse,
    permission: 'stock.depots.view',
    module: 'stock',
    section: 'Stock',
    order: 47,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission('stock.depots.view'),
  component: DepotsTab,
})
